import { GetProcessMapResponseSchema } from './get-process-map.schema';
import { z } from 'zod';
// TODO: Review AI Code for feature: Process Map - Entire file is AI-generated
/**
 * Get Process Map Endpoint Contract
 * Retrieves the process landscape map for the organization
 */ export const getProcessMapContract = {
    method: 'GET',
    path: '/api/v2/process/map',
    description: 'Retrieve the organization-wide process landscape map with connections and metrics',
    requestSchema: z.object({}),
    responseSchema: GetProcessMapResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated'
        }
    }
};

//# sourceMappingURL=get-process-map.contract.js.map